export default class CalculatedConcurrentUser {
  constructor({element: element}){
    this.timeout = {};
    this.animatedCounter= {};
    this.concurrentData = {};
    this.oldValue= 0;
    this.speed= 5000;
    this.$element = $(element);
    this.animateCounterActive = false;
    this.livestreamingId = this.$element.data("id");
    this.currentConcurrentData = parseInt(this.$element.text());
    this.interval = setInterval(this.processDataChange.bind(this), this.speed);
  }

  setConcurrentUserCount(data){
    this.concurrentData = data || {};
  }

  processDataChange(){
    if(typeof this.concurrentData.total_concurrent_users === 'undefined' || this.concurrentData.total_concurrent_users === this.currentConcurrentData){
      this.animateCounter(this.currentConcurrentData,this.generateRandom(this.currentConcurrentData));
    }else{
      this.animateCounter(this.currentConcurrentData,this.concurrentData.total_concurrent_users);
    }
  }

  generateRandom(value){
    var offset = 100;
    var positiveNegativeChance = offset * 0.5;
    var randomAddition = Math.ceil(Math.random()*offset) - positiveNegativeChance;

    if(value < 50)
      randomAddition = Math.abs(randomAddition);

    if(randomAddition == 0)
      return this.generateRandom(value);
    else
      return value + randomAddition;
  }

  animateCounter(oldValue, newValue){
    var time = 2000;
    var speed = 40;
    var incrementCount = time / speed;
    var valueInterval = (newValue - oldValue) / incrementCount;

    valueInterval = valueInterval > 0 ? Math.ceil(valueInterval) : Math.floor(valueInterval);
    oldValue = parseInt(oldValue);

    if(this.animateCounterActive == false){
      this.animateCounterActive = true;
      this.animateCounterText(oldValue,newValue,valueInterval,speed);
    }
  }

  animateCounterText(oldValue, newValue, valueInterval,speed){
      if((oldValue + valueInterval) < 0)
        oldValue = 0;
      else
        oldValue += valueInterval;
      this.$element.text(oldValue);

      if((valueInterval > 0 && oldValue >= newValue) || (valueInterval < 0 && oldValue <= newValue) || oldValue == 0 || valueInterval == 0){
        clearTimeout(this.timeout);
        this.currentConcurrentData = oldValue;
        setTimeout(this.deactivateAnimateCounterActive.bind(this), 500);
      }else{
        this.timeout = setTimeout(this.animateCounterText.bind(this, oldValue, newValue, valueInterval, speed), speed);
      }
  }

  deactivateAnimateCounterActive(){
    this.animateCounterActive = false;
  }
}
